import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-discord',
  templateUrl: './discord.component.html',
  styleUrls: ['./discord.component.scss']
})
export class DiscordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
